<app-consolidated-dashboard
  [glamSubscriptions]="subscribersRealtimeTotal"
  [class.slide-right]="index() === 0"
  [show]="signals[0]"
/>
<ng-container>
  <app-analytics-dashboard
    [subscribersRealtimeTotal]="subscribersRealtimeTotal"
    [defaultSubscriptionId]="0"
    [class.slide-right]="index() === 1"
    [show]="signals[1]"
  />
</ng-container>
